import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tenantsApi } from '../api/tenants.api';
import type { AssignPlanRequest } from '../types/tenants.types';
import { tenantsKeys } from './queryKeys';

export const useAssignPlan = (tenantId: string) => {
  const queryClient = useQueryClient();

  const assignPlan = useMutation({
    mutationFn: (data: AssignPlanRequest) => tenantsApi.assignPlan(tenantId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantsKeys.detail(tenantId) });
      queryClient.invalidateQueries({ queryKey: tenantsKeys.lists() });
    },
  });

  return {
    assignPlan: assignPlan.mutate,
    isAssigning: assignPlan.isPending,
  };
};

export const useRevertPlanAssignment = (tenantId: string) => {
  const queryClient = useQueryClient();

  const revertAssignment = useMutation({
    mutationFn: (reason: string | null) => tenantsApi.revertPlanAssignment(tenantId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantsKeys.detail(tenantId) });
      queryClient.invalidateQueries({ queryKey: tenantsKeys.lists() });
    },
  });

  return {
    revertAssignment: revertAssignment.mutate,
    isReverting: revertAssignment.isPending,
  };
};
